import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Google Maps JavaScript API key.
// Env var is REACT_APP_GOOGLE_MAPS_API_KEY (matches the .env value already
// provisioned for this app — same key configuration used by Drivons Market).
// Exported as MAPS_KEY so the import name matches the Market pattern:
//   import { MAPS_KEY } from "@/lib/api";
export const MAPS_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
  // Global 20 s timeout. Defensive: prevents iOS Capacitor / WKWebView
  // hangs (observed on cold-start with `withCredentials` + `capacitor://`
  // origin) from freezing React state indefinitely. Safari desktop and
  // Chrome resolve every real endpoint in well under a second so this
  // never fires on the web path — behavior is unchanged there.
  timeout: 20000,
});

// Attach bearer token as fallback for cross-domain cookie issues
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("haulhub_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" ");
  return String(detail);
}
